<div class="animated fadeIn">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="row m-0">
            <div class="card mb-0 p-0 mr-1" *ngFor="let cat of categories">
              <div class="card-block p-0 clearfix">
                <ul class="nav navbar-nav ml-auto">
                  <li class="nav-item">
                    <a
                      [routerLink]="['/menu/list', {type: cat.type}]"
                      href="javascript:void(0);"
                      role="button"
                      class="nav-link p-0 text-primary"
                      title="{{cat.visual}}"
                    >
                      <i class="fa fa-{{cat.icon}} btn-primary p-1 font-md"></i>
                      <span class="mx-1 hidden-sm-down">{{cat.visual}}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="loading" class="dataLoader"></div>

        <div *ngIf="!loading">
          <div class="card-block">
            <div class="row">
              <div class="col-sm-6 text-brand-primary-1">{{visuals.sender}} : {{mail.sender}}</div>
              <div class="col-sm-6 text-brand-primary-1 text-sm-right">
                {{mail.sendDt | date:'short'}}
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12  text-brand-primary-1">
                {{visuals.subject}} : {{mail.subject}}
              </div>
            </div>

            <div class="content row">
              <blockquote class="border-left-0 col-sm-12">
                <p class="text-muted h6">{{mail.body}}</p>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
